// JS
import './js/helpers'
import './js/countdown.js'
import './js/zoomtool.js'
import './js/watcher'
import 'regenerator-runtime/runtime.js';
import { io } from "socket.io-client";

// CSS

// JS in all pages

// open notebook in new window
const notebookMenuItem = document.querySelector('.notebook-menu-item');

if(notebookMenuItem) {
    notebookMenuItem.onclick = function(event) {
        event.preventDefault();
        window.open(event.target.href, 'notebook', 'menubar=no,toolbar=no,scrollbars=1,resizable=yes,location=no,status=no,width=500,height=700');
    }
}